<span class="header-user-icon" 
      [matTooltip]="$safeNavigationMigration(userInfos?.firstname) + ' ' + $safeNavigationMigration(userInfos?.lastname)"
      [matTooltipDisabled]="context === 'menu'"
      [ngClass]="context">{{userInfos?.acronymName}}</span>

@if(context === 'menu'){
    <span class="arrow-element" [ngClass]="context"><i class="fa-solid fa-chevron-down"></i></span>
}
